(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-header-logo"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cm-logo-banner__intro').forEach((intro) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const link = intro.closest('a');
  const homeLink = link.classList.contains('cm-logo-banner__link--home');
  const key = 'cm-bike-intro-seen';
  const image = intro.querySelector('img');
  let timer;
  let playing = false;
  const play = () => {
    if (playing) return;
    playing = true;
    image.onload = () => {
      intro.hidden = false;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => { intro.hidden = true; playing = false; }, 3850);
    };
    image.onerror = () => { intro.hidden = true; playing = false; };
    image.src = '';
    image.src = image.dataset.src;
  };
  if (homeLink) {
    link.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') play(); });
    link.addEventListener('focus', play);
  }
  let seen = false;
  try { seen = Boolean(sessionStorage.getItem(key)); } catch (error) {}
  if (homeLink) {
    play();
  } else if (!seen) {
    play();
    try { sessionStorage.setItem(key, '1'); } catch (error) {}
  }
});
  } catch(e) { console.error(e); }
})();

})();
